var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypcnTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4582 9.37638C25.1139 9.18476 24.7351 9.0629 24.3436 9.01777C23.9521 8.97264 23.5556 9.00513 23.1766 9.11338C22.7977 9.22162 22.4438 9.4035 22.1353 9.64862C21.8267 9.89373 21.5694 10.1973 21.3782 10.5419L15.8087 20.5649L12.6212 17.3774C12.3445 17.0908 12.0135 16.8623 11.6475 16.7051C11.2814 16.5478 10.8878 16.4651 10.4894 16.4616C10.0911 16.4582 9.69607 16.5341 9.32738 16.6849C8.95869 16.8358 8.62374 17.0585 8.34206 17.3402C8.06038 17.6219 7.83762 17.9568 7.68678 18.3255C7.53594 18.6942 7.46003 19.0892 7.46349 19.4876C7.46695 19.8859 7.54971 20.2796 7.70694 20.6456C7.86417 21.0116 8.09271 21.3426 8.37924 21.6194L14.3792 27.6194C14.9462 28.1879 15.7112 28.4999 16.5002 28.4999L16.9157 28.4699C17.3756 28.4056 17.8142 28.2354 18.1971 27.9727C18.58 27.7101 18.8967 27.3622 19.1222 26.9564L26.6222 13.4564C26.8137 13.1121 26.9355 12.7334 26.9806 12.342C27.0258 11.9506 26.9934 11.5542 26.8853 11.1753C26.7772 10.7964 26.5955 10.4426 26.3507 10.1339C26.1058 9.82524 25.8026 9.56784 25.4582 9.37638Z",
    fill: "#01C413"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypcnTick);
export default __webpack_public_path__ + "static/media/typcn_tick.0b200a13d0828b12f2019484848599fb.svg";
export { ForwardRef as ReactComponent };